import { render, staticRenderFns } from "./testRecibo.vue?vue&type=template&id=cbd80140&"
import script from "./testRecibo.vue?vue&type=script&lang=js&"
export * from "./testRecibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports